/* v2: cartao de produto com um so link focavel por produto. O link da foto duplica o do titulo,
   entao sai da ordem de tabulacao e da leitura de tela. Roda de novo quando os filtros trocam a grade. */
(function () {
  function ajustar(raiz) {
    (raiz || document).querySelectorAll('.product-card__figure > a').forEach(function (a) {
      if (a.getAttribute('tabindex') === '-1') return;
      a.setAttribute('tabindex', '-1');
      a.setAttribute('aria-hidden', 'true');
    });
  }
  ajustar();
  // observa a secao inteira (nao so .collection__results): os filtros trocam a grade com replaceChildren e o no observado sumiria
  var res = document.querySelector('.collection__results');
  var alvo = (res && res.closest('.shopify-section')) || document.body;
  new MutationObserver(function () { ajustar(alvo); }).observe(alvo, { childList: true, subtree: true });
})();
